import { Logo } from "@/components/common/Logo";
import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="relative z-10 border-t border-maroon/12 bg-cream-dark">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <Logo light />
            <p className="text-ink/60 text-sm mt-5 max-w-sm leading-relaxed">
              PMR Events is the AI-powered photography platform that helps studios deliver smarter
              galleries, effortless face discovery and beautiful album selection.
            </p>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.24em] text-maroon mb-4">Product</h4>
            <ul className="space-y-3 text-sm text-ink/60">
              <li><a href="#how" className="hover:text-maroon transition-colors">How it works</a></li>
              <li><a href="#face" className="hover:text-maroon transition-colors">AI Face Search</a></li>
              <li><a href="#features" className="hover:text-maroon transition-colors">Features</a></li>
              <li><Link to="/pricing" className="hover:text-maroon transition-colors">Pricing</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-xs uppercase tracking-[0.24em] text-maroon mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-ink/60">
              <li><Link to="/register" className="hover:text-maroon transition-colors">Get Started</Link></li>
              <li><Link to="/login" className="hover:text-maroon transition-colors">Sign in</Link></li>
              <li><a href="#faq" className="hover:text-maroon transition-colors">FAQ</a></li>
            </ul>
          </div>
        </div>
        <div className="mt-14 pt-8 border-t border-maroon/12 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-ink/50">© 2026 PMR Events. Your Memories, Smarter.</p>
          <p className="text-xs text-ink/50">Privacy-first · Face data encrypted · Consent required</p>
        </div>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2 text-center">
          <img src="/pmr-logo.png" alt="PMR Events" className="w-8 h-8 object-contain" />
          <p className="text-xs text-ink/60" data-testid="developer-credit">
            Developed by <span className="font-semibold text-maroon">Sonal Singh and Team</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
